import { Route, Switch } from "react-router";

import About from "./pages/about/about.component";
import Blogs from "./pages/blogs/blogs.component";
import Contact from "./pages/contact/contact.component";
import Home from "./pages/home/home.component";
import Work from "./pages/work/work.component";
import AutoDownload from "./pages/resume/resume.component";
import LRModelPY from "./components/mlfw/linear.regression/lrmodelpy.component";

import "./styles/design-system.css";
import "./App.css";
import NotFound from "./pages/notfound/notfound.component";
import LRModelJDK from "./components/mlfw/linear.regression/lrmodel.component";
import SevenChecker from "./components/sevenchecker/sevenchecker.component";
import Poems from "./pages/poems/poems.component";
import NetflixStyleProjectSection from "./components/netflixstyle/netflixstyleproject.section";
import Navbar from "./components/navbar/navbar.component";
import Footer from "./components/footer/footer.component";
import PortfolioFooter from "./components/portfolio/portfolio-footer.component";

function App() {
  return (
    <div className="app">
      <Switch>
        <Route exact path="/" component={Home} />
        <Route path="/about" component={About} />
        <Route path="/projectsnew" component={NetflixStyleProjectSection} />
        <Route path="/projects" component={Work}/>
        <Route path="/contact" component={Contact} />
        <Route path="/blogs" component={Blogs} />
        <Route path="/download" component={AutoDownload} />
        <Route path="/ml/lrmodel" component={LRModelPY} />
        <Route path="/ml/lrmodelj" component={LRModelJDK} />
        <Route path="/sevenchecker" component={SevenChecker} />
        <Route path="/poems" component={Poems} />
        <Route path="*" component={NotFound} />
      </Switch>
    </div>
  );
}

export default App;
